<template>
  <div class="col responsive-width">
    <div class="container-fluid">
      <div class="content">
        <authorization-banner/>
        <div class="headers d-flex">
          <h1 class="mb-0">{{ $t("invoices") }}</h1>
          <router-link :to="{ name: 'createInvoice' }" class="ms-auto">
            <svg
                width="31"
                height="30"
                viewbox="0 0 31 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M22.6541 0C27.7541 0 30.6641 2.88 30.6641 7.995V22.005C30.6641 27.09 27.7691 30 22.6691 30H8.65906C3.54406 30 0.664062 27.09 0.664062 22.005V7.995C0.664062 2.88 3.54406 0 8.65906 0H22.6541ZM15.6491 8.265C14.9591 8.265 14.4041 8.82 14.4041 9.51V13.74H10.1591C9.82906 13.74 9.51406 13.875 9.27406 14.1C9.04906 14.34 8.91406 14.6535 8.91406 14.985C8.91406 15.675 9.46906 16.23 10.1591 16.245H14.4041V20.49C14.4041 21.18 14.9591 21.735 15.6491 21.735C16.3391 21.735 16.8941 21.18 16.8941 20.49V16.245H21.1541C21.8441 16.23 22.3991 15.675 22.3991 14.985C22.3991 14.295 21.8441 13.74 21.1541 13.74H16.8941V9.51C16.8941 8.82 16.3391 8.265 15.6491 8.265Z"
                  fill="#7754FB"
              ></path>
            </svg>
          </router-link>
          <button
              class="btn btn-outline-primary sync-btn"
              v-on:click="syncInvoice"
          >
            <i
                class="bx bx-refresh bx-xs"
                :class="{ 'bx-spin': syncing === true }"
            ></i>
          </button>
        </div>
        <nav>
          <div class="row">
            <div class="col">
              <ul class="list-unstyled d-flex">
                <li
                    @click="filterInvoices('all')"
                    :class="selectedFilter === 'all' ? 'active-filter' : ''"
                    class="all"
                >
                  {{ $t("all") }}
                </li>
                <li
                    @click="filterInvoices('not-booked')"
                    :class="
                    selectedFilter === 'not-booked' ? 'active-filter' : ''
                  "
                    class="not-booked"
                >
                  {{ $t("not_book") }}
                </li>
                <li
                    @click="filterInvoices('booked')"
                    :class="selectedFilter === 'booked' ? 'active-filter' : ''"
                    class="booked"
                >
                  {{ $t("booked") }}
                </li>
                <li
                    @click="filterInvoices('unpaid')"
                    :class="selectedFilter === 'unpaid' ? 'active-filter' : ''"
                    class="unpaid"
                >
                  {{ $t("unpaid") }}
                </li>
                <li
                    @click="filterInvoices('paid')"
                    :class="selectedFilter === 'paid' ? 'active-filter' : ''"
                    class="fully-paid"
                >
                  {{ $t("fully_paid") }}
                </li>
                <li
                    @click="filterInvoices('void')"
                    :class="selectedFilter === 'void' ? 'active-filter' : ''"
                    class="voided"
                >
                  {{ $t("voided") }}
                </li>
              </ul>
            </div>
            <!-- <div class="col applyFilter">
              <p>Filter</p>
              <select
                v-model="applyFilter"
                v-on:change="onChange"
                style="width: 80px"
              >
                <option value="All">All</option>
                <option value="?filter=sent_via_regular">
                  Sent to customer
                </option>
                <option value="?filter=sent_via_nox">
                  Sent via Fortnox Fakturaserivce
                </option>
                <option value="?filter=not_sent">Not sent</option>
              </select>
              <ul class="list-unstyled d-flex">
                <li @click="filterInvoices('void')" class="apply">Apply</li>
              </ul>
            </div> -->
            <div class="col">
              <div class="right-parent">
                <div class="filter d-flex">
                  <label>Filter</label>
                  <custom-select-drop-down :width="`175px`" :default-value="defaultValue" :key="defaultValue" :options="optionsList"
                                           @onPicked="onPicked"/>
                  <button @click="clearFilter">{{ $t("clearFilter") }}</button>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                  <div class="search">
                    <label for="search">
                      <svg
                          width="15"
                          height="15"
                          viewbox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M14.6219 13.5596L10.0568 8.99453C10.7652 8.07871 11.1484 6.95898 11.1484 5.78125C11.1484 4.37148 10.5982 3.04961 9.60332 2.05293C8.6084 1.05625 7.28301 0.507812 5.875 0.507812C4.46699 0.507812 3.1416 1.05801 2.14668 2.05293C1.15 3.04785 0.601562 4.37148 0.601562 5.78125C0.601562 7.18926 1.15176 8.51465 2.14668 9.50957C3.1416 10.5063 4.46523 11.0547 5.875 11.0547C7.05273 11.0547 8.1707 10.6715 9.08652 9.96484L13.6516 14.5281C13.6649 14.5415 13.6808 14.5521 13.6983 14.5594C13.7158 14.5666 13.7346 14.5704 13.7535 14.5704C13.7725 14.5704 13.7912 14.5666 13.8087 14.5594C13.8262 14.5521 13.8421 14.5415 13.8555 14.5281L14.6219 13.7635C14.6353 13.7501 14.6459 13.7342 14.6531 13.7167C14.6604 13.6992 14.6641 13.6805 14.6641 13.6615C14.6641 13.6426 14.6604 13.6238 14.6531 13.6063C14.6459 13.5889 14.6353 13.573 14.6219 13.5596ZM8.65938 8.56563C7.91406 9.30918 6.92617 9.71875 5.875 9.71875C4.82383 9.71875 3.83594 9.30918 3.09063 8.56563C2.34707 7.82031 1.9375 6.83242 1.9375 5.78125C1.9375 4.73008 2.34707 3.74043 3.09063 2.99688C3.83594 2.25332 4.82383 1.84375 5.875 1.84375C6.92617 1.84375 7.91582 2.25156 8.65938 2.99688C9.40293 3.74219 9.8125 4.73008 9.8125 5.78125C9.8125 6.83242 9.40293 7.82207 8.65938 8.56563Z"
                            fill="#8F8E94"
                        ></path>
                      </svg>
                    </label>
                    <input
                        @input="searchField"
                        id="search"
                        type="text"
                        :placeholder="$t('search')"
                    />
                  </div>
                  <div class="customize">
                    <a
                        class="d-flex"
                        href="javascript:void(0);"
                        @click="openInvoiceCustomizationModal = true"
                    >
                      <svg
                          width="14"
                          height="13"
                          viewbox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M5.83724 7.2474H1.58724C1.39938 7.2474 1.21921 7.32202 1.08637 7.45486C0.953534 7.5877 0.878906 7.76787 0.878906 7.95573V12.2057C0.878906 12.3936 0.953534 12.5738 1.08637 12.7066C1.21921 12.8394 1.39938 12.9141 1.58724 12.9141H5.83724C6.0251 12.9141 6.20527 12.8394 6.33811 12.7066C6.47094 12.5738 6.54557 12.3936 6.54557 12.2057V7.95573C6.54557 7.76787 6.47094 7.5877 6.33811 7.45486C6.20527 7.32202 6.0251 7.2474 5.83724 7.2474ZM5.12891 11.4974H2.29557V8.66406H5.12891V11.4974ZM12.9206 0.164062H8.67057C8.48271 0.164063 8.30254 0.23869 8.16971 0.371528C8.03687 0.504367 7.96224 0.684534 7.96224 0.872396V5.1224C7.96224 5.31026 8.03687 5.49042 8.16971 5.62326C8.30254 5.7561 8.48271 5.83073 8.67057 5.83073H12.9206C13.1084 5.83073 13.2886 5.7561 13.4214 5.62326C13.5543 5.49042 13.6289 5.31026 13.6289 5.1224V0.872396C13.6289 0.684534 13.5543 0.504367 13.4214 0.371528C13.2886 0.23869 13.1084 0.164063 12.9206 0.164062ZM12.2122 4.41406H9.37891V1.58073H12.2122V4.41406ZM12.9206 9.3724H11.5039V7.95573C11.5039 7.76787 11.4293 7.5877 11.2964 7.45486C11.1636 7.32202 10.9834 7.2474 10.7956 7.2474C10.6077 7.2474 10.4275 7.32202 10.2947 7.45486C10.1619 7.5877 10.0872 7.76787 10.0872 7.95573V9.3724H8.67057C8.48271 9.3724 8.30254 9.44702 8.16971 9.57986C8.03687 9.7127 7.96224 9.89287 7.96224 10.0807C7.96224 10.2686 8.03687 10.4488 8.16971 10.5816C8.30254 10.7144 8.48271 10.7891 8.67057 10.7891H10.0872V12.2057C10.0872 12.3936 10.1619 12.5738 10.2947 12.7066C10.4275 12.8394 10.6077 12.9141 10.7956 12.9141C10.9834 12.9141 11.1636 12.8394 11.2964 12.7066C11.4293 12.5738 11.5039 12.3936 11.5039 12.2057V10.7891H12.9206C13.1084 10.7891 13.2886 10.7144 13.4214 10.5816C13.5543 10.4488 13.6289 10.2686 13.6289 10.0807C13.6289 9.89287 13.5543 9.7127 13.4214 9.57986C13.2886 9.44702 13.1084 9.3724 12.9206 9.3724ZM5.83724 0.164062H1.58724C1.39938 0.164063 1.21921 0.23869 1.08637 0.371528C0.953534 0.504367 0.878906 0.684534 0.878906 0.872396V5.1224C0.878906 5.31026 0.953534 5.49042 1.08637 5.62326C1.21921 5.7561 1.39938 5.83073 1.58724 5.83073H5.83724C6.0251 5.83073 6.20527 5.7561 6.33811 5.62326C6.47094 5.49042 6.54557 5.31026 6.54557 5.1224V0.872396C6.54557 0.684534 6.47094 0.504367 6.33811 0.371528C6.20527 0.23869 6.0251 0.164063 5.83724 0.164062ZM5.12891 4.41406H2.29557V1.58073H5.12891V4.41406Z"
                            fill="#5855D6"
                        ></path>
                      </svg>
                      {{ $t("customize") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div class="box">
          <div
              :class="[
              'box-responsive',
              `cols-count-${invoiceCustomizeItem.length + 2}`,
            ]"
          >
            <table>
              <thead>
              <tr>
                <th width="30" class="text-center">
                  <div class="checkbo">
                    <input
                        type="checkbox"
                        v-model="toggleChangeCheckbox"
                        class="form-check-input"
                        @change="toggleAllCheckbox"
                    />
                    <!-- <svg width="21" height="20" viewbox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.28201" y="0.664818" width="18.5834" height="18.5834" rx="3.42325" fill="#5855D6" stroke="#5855D6" stroke-width="0.978073"></rect>
                    <path d="M14.8057 5.95575C15.0124 5.75899 15.2874 5.65022 15.5727 5.65238C15.8581 5.65453 16.1314 5.76746 16.3351 5.96732C16.5387 6.16718 16.6568 6.43834 16.6643 6.72359C16.6719 7.00884 16.5683 7.28587 16.3755 7.49621L10.5217 14.8171C10.4211 14.9255 10.2996 15.0125 10.1645 15.0729C10.0295 15.1333 9.88365 15.1658 9.73574 15.1686C9.58782 15.1713 9.44087 15.1442 9.30368 15.0888C9.16648 15.0335 9.04186 14.951 8.93726 14.8464L5.05529 10.9645C4.94718 10.8637 4.86047 10.7422 4.80033 10.6073C4.74019 10.4723 4.70786 10.3266 4.70525 10.1789C4.70264 10.0311 4.72982 9.88435 4.78516 9.74734C4.8405 9.61033 4.92287 9.48587 5.02736 9.38139C5.13184 9.2769 5.2563 9.19453 5.39331 9.13919C5.53033 9.08385 5.67708 9.05667 5.82482 9.05928C5.97256 9.06189 6.11827 9.09422 6.25324 9.15436C6.38821 9.2145 6.50969 9.30121 6.61042 9.40932L9.68255 12.48L14.7778 5.98802C14.787 5.97673 14.7968 5.96595 14.8072 5.95575H14.8057Z" fill="#F6F8FC"></path>
                  </svg> -->
                  </div>
                </th>
                <th v-for="(item, i) in tableHeader" :key="i">
                  <div style="display: flex">
                      <span>{{
                          $services.helpers.capitalizeNames($t(item))
                        }}</span
                      ><span
                      v-if="!item_to_exclude.includes(item)"
                      class="th-soring"
                  >
                        <i
                            class="bx bx-chevron-up bx-xs el-clickable"
                            v-if="sortableColumns.includes(item)"
                            v-on:click="sortAscBy(i, item)"
                        ></i>
                        <i
                            class="bx bx-chevron-down bx-xs el-clickable"
                            v-if="sortableColumns.includes(item)"
                            v-on:click="sortDescBy(i, item)"
                        ></i>
                      </span>
                  </div>
                </th>
                <th width="90">
                  <span>{{ $t("actions") }}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  :class="{
                    voided: item.cancelled === true,
                    fullypaid: item.fully_paid === true,
                    booked: item.booked === true,
                    notbooked: item.booked === false,
                    unpaid: isUnPaid(item),
                  }"
                  v-for="item in GET_INVOICE.data"
                  :key="item.id"
              >
                <InvoiceTable
                    :data="item"
                    :head="tableHeader"
                    @registerPayment="openRegisterModal"
                    @createCopyInvoice="openCreateCopy"
                    @sendInvoice="sendSingleInvoice"
                    @scheduleInvoiceSendout="singleRowSchedule"
                />
              </tr>
              </tbody>
            </table>
          </div>
          <div
              v-if="GET_INVOICE.length < 1"
              class="d-flex justify-content-center"
          >
            <div class="loader">Loading...</div>
          </div>
        </div>
        <div class="actions d-flex align-items-center">
          <label>{{ $t("actions") }}</label>
          <select v-model="action">
            <option value="cancel">{{ $t("void") }}</option>
            <option value="bookkeep">{{ $t("bookkeep") }}</option>
            <!-- <option value="register">Register Payment</option> -->
            <option value="send">{{ $t("send") }}</option>
            <option value="schedule">
              {{ $t("schedule_invoice_send_out") }}
            </option>
          </select>
          <button type="submit" :disabled="applying" @click="applyAction">
            <span v-if="applying">{{ $t("applying") }}</span>
            <span v-else>{{ $t("apply") }}</span>
          </button>
          <div class="d-flex justify-content-end w-full">
            <div style="margin-right: 20px">
              <p class="list-summary">
                <select
                    v-model="limit"
                    v-on:change="onChange"
                    style="width: 67px"
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
                of {{ GET_INVOICE.total_resources }}
              </p>
            </div>
            <v-pagination
                v-model="GET_INVOICE.page"
                :pages="GET_INVOICE.total_pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="changePageNumber"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalBoxVue
      v-if="openInvoiceCustomizationModal"
      customize="customize"
      @handleClose="openInvoiceCustomizationModal = false"
      :close="!true"
  >
    <div class="container p-3">
      <p>Uppdatera ordningen på kolumnerna <small> (drag &amp; drop)</small></p>
      <!-- list all visible columns -->
      <div class="row small">
        <div class="col-md-12">
          <!-- draggable list of visible columns -->
          <ul class="list-group" id="sortlist">
            <li
                v-for="item in invoiceCustomizeItem"
                :key="item"
                class="list-group-item list-group-item-action"
                style="cursor: grab"
            >
              <div class="d-flex justify-content-start">
                <img
                    style="width: 20px; height: 20px; margin-right: 10px"
                    src="../../assets/images/icon-utility/drag-and-drop.svg"
                    alt="d&amp;d-icon"
                />
                <div>
                  <span>{{ $t(item) }}</span>
                </div>
              </div>
            </li>
          </ul>
          <!-- <div class="list-group" v-for="(item, i) in tableHeader" :key="i">
            <p
              class="list-group-item list-group-item-action"
              :class="{
                active: item == activeColumn,
                disabled: item_to_exclude.includes(item),
              }"
              @click="setActiveColumn(item)"
            >
              {{ $t(item) }}
            </p>
          </div> -->
        </div>
      </div>
    </div>
    <h4>{{ $t("customization_invoice") }}</h4>
    <div class="container p-3">
      <small>{{ $t("select_columns") }}</small>
      <form @submit.prevent="updateInvoiceCustomization">
        <div class="customize-cols-scrollar">
          <div
              class="form-check"
              v-for="(item, i) in Object.keys(INVOICE_CUSTOMIZATION)"
              :key="i"
          >
            <input
                class="form-check-input"
                @change="onChangeCheckbox"
                v-model="invoiceCustomizeItem"
                type="checkbox"
                :value="item"
            />
            <label class="form-check-label" for="flexCheckDefault">
              {{ INVOICE_CUSTOMIZATION[item] }}
            </label>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <button type="submit" :disabled="updating" class="btn btn-primary">
            <span v-if="updating">{{ $t("updating") }}...</span>
            <span v-else>{{ $t("update") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openModalSendInvoice"
      @handleClose="openModalSendInvoice = false"
      :close="!true"
  >
    <div class="popup-box2">
      <h4 style="text-align: left !important">{{ $t("send_invoices") }}</h4>
      <form class="popup-body" @submit.prevent="sendInvoice">
        <label>{{ $t("invoice") }} {{ $t("type") }}</label>
        <select v-model="invoiceType" required>
          <option value="fortnox">Fortnox Fakturaservice</option>
          <option value="regular">Regular Invoice</option>
        </select>
        <label v-if="invoiceType === 'regular'">{{ $t("send_method") }}</label>
        <select v-if="invoiceType === 'regular'" v-model="sendMethod" required>
          <option value="email">{{ $t("email") }}</option>
          <option value="einvoice">{{ $t("e_invoice") }}</option>
        </select>
        <label v-if="invoiceType === 'fortnox'">{{ $t("send_method") }}</label>
        <select v-if="invoiceType === 'fortnox'" v-model="sendMethod" required>
          <option value="EMAIL">{{ $t("email") }}</option>
          <option value="LETTER">{{ $t("letter") }}</option>
          <option value="NONE">{{ $t("do_not_send_nox") }}</option>
        </select>

        <div class="popup-bottons">
          <button @click="openModalSendInvoice = false">
            {{ $t("cancel") }}
          </button>
          <button :disabled="sending" type="submit">
            <span v-if="sending">{{ $t("sending") }}</span>
            <span v-else>{{ $t("send") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openModalRegisterPayment"
      @handleClose="openModalRegisterPayment = false"
      :close="!true"
  >
    <div class="popup-box2">
      <h4 style="text-align: left !important">{{ $t("register_payment") }}</h4>
      <form class="popup-body" @submit.prevent="registerPayment">
        <label>{{ $t("payment_date") }}</label>
        <input type="date" v-model="paymentDate" required/>
        <div class="currency-container">
          <label>{{ $t("payment_amount") }}</label>
          <input
              type="number"
              min="0"
              step="0.1"
              v-model="paymentAmount"
              required
              style="padding-right: 42px"
          />
          <span class="currency">{{ selectedInvoicePayment.currency }}</span>
        </div>

        <div>
          <label>{{ $t("mode_of_payment_account") }}</label>
          <input
              type="text"
              v-model="paymentMode"
              required
              @input="searchAccountField"
          />
          <div
              v-if="showAccount"
              style="z-index: 9999; width: 150px"
              class="position-absolute bg-white rounded shadow-md border p-2"
          >
            <ul style="padding-left: 0.3rem !important; list-style-type: none">
              <li
                  class="border-bottom mb-1 cursor-pointer text-xs"
                  v-for="item in accounts.slice(0, 5)"
                  :key="item.number"
                  @click="chooseAccount(item)"
              >
                {{ item.number }} {{ item.description }}
              </li>
            </ul>
          </div>
        </div>

        <div class="popup-bottons">
          <button type="submit" @click="openModalRegisterPayment = false">
            {{ $t("cancel") }}
          </button>
          <button :disabled="sending" type="submit">
            <span v-if="sending">{{ $t("registering") }}...</span>
            <span v-else>{{ $t("register") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openFailedInvoices"
      @handleClose="openFailedInvoices = false"
      :close="!true"
  >
    <div class="popup-box2">
      <h4 style="text-align: left !important">{{ $t("failed_invoices") }}</h4>
      <div class="p-3">
        <h5>
          {{ $t("the") }} {{ $t("following") }} ({{ failedInvoice.length }})
          {{ $t("invoices") }} {{ $t("failed") }}
        </h5>
        <p v-for="(item, i) in failedInvoice" :key="i">
          <span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                style="color: red"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
              <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
              />
            </svg>
          </span>
          <span>{{ $t("invoice_number") }}: {{ item.invoice_id }}</span>
        </p>
      </div>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
      v-if="openScheduleInvoiceSendoutModal"
      @handleClose="openScheduleInvoiceSendoutModal = false"
      :close="!true"
  >
    <div class="popup-box2">
      <h4 style="text-align: left !important">
        {{ $t("schedule_invoice_send_out") }}
      </h4>
      <div class="container p-3">
        <!-- <form @submit.prevent="updateContractCustomization"> -->
        <form @submit.prevent>
          <div class="customize-cols-scrollar">
            <div class="col-md-8">
              <small>{{ $t("date_to_send") }}</small>
              <Datepicker
                  class="form-control"
                  v-model="date_to_send"
                  format="yyyy-MM-dd"
                  :enableTimePicker="false"
                  :minDate="today"
              />
            </div>
            <div class="col-md-8">
              <label>{{ $t("invoice_type") }}</label>
              <select v-model="invoice_type" class="form-control">
                <option value="" selected>{{ $t("choose_an_option") }}</option>
                <option value="nox_finans">
                  {{ $t("fortnox_invoice_service") }}
                </option>
                <option value="regular">{{ $t("regular") }}</option>
              </select>
            </div>
            <div class="col-md-8">
              <label>{{ $t("distribution_method") }}</label>
              <select v-model="distribution_method" class="form-control">
                <option value="" selected>{{ $t("choose_an_option") }}</option>
                <option value="email">{{ $t("as_email") }}</option>
                <option value="einvoice">{{ $t("e_invoice") }}</option>
                <option v-if="invoice_type === 'nox_finans'" value="print">
                  {{ $t("letter") }}
                </option>
              </select>
            </div>
            <div class="col-md-8">
              <input
                  v-model="bookkeep"
                  style="box-shadow: none !important"
                  class="checkbox"
                  type="checkbox"
                  id="bookkeep-id"
                  name="bookkeep-name"
              />
              <label for="bookkeep-id"> {{ $t("bookkeep_invoice") }} </label
              ><br/>
            </div>
            <div class="col-md-12">
              <input
                  v-model="send_failed_nox_as_reg"
                  style="box-shadow: none !important"
                  class="checkbox"
                  type="checkbox"
                  id="send-failed-nox-as-reg-id"
                  name="send-failed-nox-as-reg-name"
              />

              <label for="send-failed-nox-as-reg-id">
                {{ $t("send_failed_nox_as_reg_2") }} </label
              ><br/>
            </div>
          </div>
          <div class="col-md-12 mt-2">
            <span v-if="!isBulk && targetRow.scheduled_invoice_sending.length">
              <button
                  :disabled="scheduling || !canScheduleInvoiceSendout"
                  class="btn btn-primary"
                  @click="updateScheduleInvoiceSendout()"
              >
                {{ $t("update") }}
              </button>
              <button
                  :disabled="scheduling"
                  class="btn btn-warning"
                  @click="deleteScheduleInvoiceSendout"
              >
                {{ $t("delete") }}
              </button>
            </span>

            <button
                :disabled="scheduling || !canScheduleInvoiceSendout"
                v-else
                class="btn btn-primary"
                @click="addScheduleInvoiceSendout"
            >
              {{ $t("save") }}
            </button>

            <button
                :disabled="scheduling"
                class="btn btn-danger"
                @click="openScheduleInvoiceSendoutModal = false"
            >
              {{ $t("cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </ModalBoxVue>
  <!-- Warning modal which shows info of those checked objects which already have scheduled cancellation -->
  <ModalBoxVue
      v-if="openAlreadyScheduledModal"
      @handleClose="openAlreadyScheduledModal = false"
      :close="!true"
  >
    <h4>{{ $t("already_scheduled_modal_title") }}</h4>
    <div class="container p-3">
      <div class="customize-cols-scrollar">
        <div class="col-md-8">
          <small>{{ $t("already_scheduled_modal_list_label") }}</small>
          <ul>
            <li v-for="item in alreadyScheduled" :key="item.id">
              <b
              >{{ $t("invoice") }}
                {{ item.scheduled_invoice_sending[0].document_number }}</b
              >: {{ item.scheduled_invoice_sending[0].date_to_send }}
            </li>
          </ul>
        </div>
        <small>
          {{ $t("already_scheduled_modal_note1") }}
          <svg style="width: 20px; height: 19px" viewBox="0 0 24 24">
            <path
                fill="#5855d6"
                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"
            />
          </svg>
          {{ $t("already_scheduled_modal_note2") }}
        </small>
        <button
            class="btn btn-primary"
            v-if="bulkScheduled.length"
            @click="toggleScheduleInvoiceSendoutModal()"
        >
          {{ $t("proceed") }}
        </button>
        <div v-else>
          <small>{{ $t("select_unscheduled_row") }}</small>
          <button
              class="btn btn-warning"
              @click="openAlreadyScheduledModal = false"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </ModalBoxVue>
</template>

<script>
import {mapGetters} from "vuex";
import debounce from "lodash.debounce";
import InvoiceTable from "./reusableComponents/InvoiceTable.vue";
import ModalBoxVue from "../../components/ModalBox.vue";
import {
  INVOICE_CUSTOMIZATION,
  INVOICE_DEFAULT,
} from "./composables/customization";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AuthorizationBanner from "./reusableComponents/AuthorizationBanner";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import customSelectDropDown from "../../components/customSelectDropDown";

const TODAY = moment().format("YYYY-MM-DD");

export default {
  name: "Invoices",
  components: {
    InvoiceTable,
    ModalBoxVue,
    customSelectDropDown,
    VPagination,
    AuthorizationBanner,
    Datepicker,
  },
  data() {
    return {
      item_to_exclude: ["tags"],
      tableHeader: [],
      invoiceCustomizeItem: [],
      optionsList: [
        {value: 'All', label: 'all'},
        {value: 'sent_via_regular', label: 'sentToCustomer'},
        {value: 'sent_via_nox', label: 'sentViaNox'},
        {value: 'not_sent', label: 'notSent'},
      ],
      filterDict: {
        unpaid: "unpaid",
        paid: "fullypaid",
        void: "voided",
        booked: "booked",
        "not-booked": "unbooked",
      },
      openInvoiceCustomizationModal: false,
      INVOICE_CUSTOMIZATION: INVOICE_CUSTOMIZATION,
      updating: false,
      toggleChangeCheckbox: false,
      openModalSendInvoice: false,
      openModalRegisterPayment: false,
      filter: null,
      statusFilter: null,
      action: "",
      defaultValue: "",
      applying: false,
      limit: 50,
      applyFilter: "All",
      invoiceType: "",
      sendMethod: "",
      services: "LEDGERBASE",
      paymentDate: "",
      paymentAmount: "",
      paymentMode: "",
      // actionNoxFinance : '',
      sending: false,
      syncing: false,
      openFailedInvoices: false,
      accounts: [],
      failedInvoice: [],
      selectedInvoicePayment: {},
      selectedData: {},
      showAccount: false,
      openScheduleInvoiceSendoutModal: false,
      date_to_send: TODAY,
      invoice_type: "",
      distribution_method: "",
      bookkeep: false,
      send_failed_nox_as_reg: false,
      scheduling: false, //this is a flag which can be used to show loading spinner etc. Mainly used for disabling buttons when requests are being processed
      targetRow: {}, //object having all the data of a single row which is selected by the user
      alreadyScheduled: [], //array of all the objects which already have scheduled cancellation but they are checked by the user, these objects will be displayed in the warning modal
      bulkScheduled: [], //array of all objects checked by the user which do not have any scheduled cancellation
      isBulk: false, //flag to determine whether the addScheduleCancellation is called by a single row or bulk action
      openAlreadyScheduledModal: false, //flag to show warning modal. It is displayed if user selects those rows which already have scheduled cancellation
      selectedFilter: "all",
      orderByColumn: null, // which column to order
      orderByQuery: "",
      sortableColumns: [
        "customer_name",
        "balance",
        "contract_reference",
        "currency",
        "sent",
        "nox_finans",
        "final_pay_date",
        "total",
        "terms_of_payment",
        "price_list",
        "cost_center",
        "project",
        "invoice_date",
      ],
    };
  },
  computed: {
    ...mapGetters({
      GET_INVOICE: "clients/GET_INVOICE",
      GET_INVOICE_CHECKED: "clients/GET_INVOICE_CHECKED",
      GET_PACKAGE: "clients/GET_PLAN_DETAIL",
      GET_USER_SUBSCRIPTION: "clients/GET_USER_SUBSCRIPTION",
      CURRENT_USER: "clients/GET_CURRENT_USER",
      INVOICE_FILTER: 'clients/GET_INVOICE_FILTER'
    }),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    canScheduleInvoiceSendout() {
      return this.date_to_send && this.invoice_type && this.distribution_method;
    },
  },
  mounted() {
    this.getUserSubscription();
    this.getInvoice();
    this.getInvoiceCustomizeHeader();
  },
  methods: {
    isUnPaid: function (item) {
      // parse the due_date to a Date object
      const dueDate = new Date(item.due_date);
      
      // get the current date
      const now = new Date();

      // Check the balance and due date, booked and cancelled
      if (parseFloat(item.balance) !== 0 && dueDate < now && item.booked && !item.cancelled) {
        return true;
      }
      
      // If balance is zero or due date is not in the past, return false
      return false;
    },
    onPicked: function (option) {
      this.applyFilter = option.value
      this.sentFilter()
    },
    getUserSubscription() {
      this.$store
          .dispatch("clients/getUserSubscription")
          .then((res) => {
            this.getPackageInfo();
          })
          .catch((err) => {
          });
    },
    getPackageInfo() {
      if (this.GET_USER_SUBSCRIPTION.length > 0) {
        if (
            !["free", "Free", "FREE"].includes(
                this.GET_USER_SUBSCRIPTION[0].current_package
            )
        ) {
          const payload = {
            URL:
                this.$services.endpoints.PACKAGE_ENDPOINT +
                `?package=${this.GET_USER_SUBSCRIPTION[0].current_package.toLowerCase()}`,
          };
          this.$store
              .dispatch("clients/getPlanDetails", payload)
              .then((res) => {
                if (
                    !res.data.results[0].dashboard_page_access.includes(
                        this.$route.name
                    )
                ) {
                  window.Bus.emit("access-denied", "invoice");
                }
              });
        } else {
          window.Bus.emit("access-denied", "invoice");
        }
      } else {
        this.getUserSubscription();
      }
    },
    searchAccountField: debounce(function (event) {
      if (event.target.value !== "") {
        this.filterAccountSearch(event.target.value);
      } else {
        this.showAccount = false;
      }
    }, 500),
    filterAccountSearch(data) {
      this.accounts = [];
      const URL =
          this.$services.endpoints.REGISTER_ENDPOINT + `accounts?search=${data}`;
      this.$store
          .dispatch("clients/getCustomRequest", {URL})
          .then((res) => {
            this.showAccount = true;
            this.accounts = res.data.results;
          })
          .catch((err) => {
          });
    },
    chooseAccount(item) {
      this.paymentMode = item.number;
      this.showAccount = false;
    },
    syncInvoice: function () {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.syncing = true;
      this.$store
          .dispatch("clients/syncResource", "invoices")
          .then(() => {
            this.syncing = false;
            // this.$services.helpers.notification('Invoices synchronization in progress', 'success', this)
            this.$toast.info(this.$t("sync_invoices"));
          })
          .catch((err) => {
            this.syncing = false;
            // this.$services.helpers.notification('Invoices could not be synchronized', 'error', this)
            this.$toast.info(this.$t("fail_sync_invoices"));
          });
    },
    onChange() {
      let payload = `limit=${this.limit}`;
      let params = this.computeQueryParam()
      if (params) {
        payload += params;
      }
      this.$store.dispatch(
          "clients/getInvoice", payload
      );
    },
    sortAscBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=${this.orderByColumn}`;
      this.$store.commit('clients/UPDATE_INVOICE_FILTER', {ordering: item})
      this.onChange();
    },
    sortDescBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=-${this.orderByColumn}`;
      this.$store.commit('clients/UPDATE_INVOICE_FILTER', {ordering: `-${item}`})
      this.onChange();
    },
    searchField: debounce(function (event) {
      this.$store.commit('clients/UPDATE_INVOICE_FILTER', {search: event.target.value})
      this.onChange()
      // if (event.target.value !== "") {
      //   this.$store.commit('clients/UPDATE_INVOICE_FILTER', {search: event.target.value})
      //   this.filterSearch(event.target.value);
      // } else {
      //   this.getInvoice();
      // }
    }, 500),
    filterSearch(data) {
      this.filter = `&search=${data}`;
      this.$store.commit("clients/UPDATE_INVOICE", []);
      let payload = this.filter + `&limit=${this.limit}`;
      this.$store.dispatch(
          "clients/getInvoice",
          this.statusFilter +
          (this.applyFilter != "All" ? `&filter=${this.applyFilter}` : ``) +
          payload +
          this.orderByQuery
      );
    },
    getInvoice() {
      this.selectedFilter = "unpaid";
      const payload = `limit=${this.limit}&filter=${this.selectedFilter}`;
      this.$store
          .dispatch("clients/getInvoice", payload)
          .then((res) => {
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$store.commit("auth/CLEAR_AUTH_USER", null);
              window.Bus.emit("logout");
            }
          });
    },
    changePageNumber(number) {
      let payload = "";
      if (this.filter) {
        payload = `page=${number}&${this.filter}`;
      } else {
        payload = `page=${number}`;
      }
      payload += `&limit=${this.limit}`;
      this.$store.commit("clients/UPDATE_INVOICE", []);
      this.$store.dispatch("clients/getInvoice", payload + this.orderByQuery);
    },
    filterInvoices(data) {
      let payload = "";
      if (data === "unpaid") {
        payload = "filter=unpaid";
      } else if (data === "paid") {
        payload = "filter=fullypaid";
      } else if (data === "void") {
        payload = "filter=voided";
      } else if (data === "booked") {
        payload = `filter=booked`;
      } else if (data === "not-booked") {
        payload = `filter=unbooked`;
      } else {
        payload = ``;
      }

      this.selectedFilter = data;
      this.$store.commit("clients/UPDATE_INVOICE", []);
      this.$store.commit('clients/UPDATE_INVOICE_FILTER', {selectedFilter: data})
      this.statusFilter = payload;
      this.applyFilter = "All";
      payload += `&limit=${this.limit}`;
      this.$store.commit("clients/UPDATE_INVOICE", []);
      this.onChange()
      // this.$store.dispatch("clients/getInvoice", payload + this.orderByQuery);
    },
    clearFilter: function () {
      this.applyFilter = ''
      this.$store.commit('clients/CLEAR_FILTER', 'invoice')
      this.defaultValue = ''
      document.getElementById('search').value = ''
      this.filterInvoices('all')
    },
    computeQueryParam() {
      if (Object.keys(this.INVOICE_FILTER).length <= 0) {
        return null
      }
      let payload = ""
      Object.keys(this.INVOICE_FILTER).map(item => {
        if (item === 'selectedFilter') {
          if (this.INVOICE_FILTER[item] !== 'all') {
            payload += `&filter=${this.filterDict[this.INVOICE_FILTER[item]]}`
          }
        } else if (item === 'filter') {
          if (this.INVOICE_FILTER[item] !== 'All') {
            payload += `&filter=${this.INVOICE_FILTER[item]}`
          }
          let ex = this.optionsList.filter(i => i.value === this.INVOICE_FILTER[item])
          if (ex.length) {
            this.defaultValue = ex[0].label
          }
        } else {
          if (this.INVOICE_FILTER[item]) {
            payload += `&${item}=${this.INVOICE_FILTER[item]}`
            if (item === 'search') {
              document.getElementById('search').value = this.INVOICE_FILTER[item]
            }
          }
        }
      })
      return payload
    },
    sentFilter() {
      let payload = "";
      if (this.applyFilter !== "All") {
        if (this.applyFilter === "sent_via_regular") {
          payload = `&filter=sent_via_regular`;
        } else if (this.applyFilter === "sent_via_nox") {
          payload = `&filter=sent_via_nox`;
        } else if (this.applyFilter === "not_sent") {
          payload = `&filter=not_sent`;
        }
      }
      this.$store.commit("clients/UPDATE_INVOICE", []);
      this.$store.commit('clients/UPDATE_INVOICE_FILTER', {filter: this.applyFilter})
      this.onChange()
      // this.$store.dispatch(
      //     "clients/getInvoice",
      //     this.statusFilter + payload + this.orderByQuery
      // );
    },
    sendInvoice() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.sendMethod === "" || this.invoiceType === "") {
        // this.$services.helpers.notification('Fields values required', 'error', this)
        this.$toast.warning(this.$t("fields_required"));
      } else {
        if (this.invoiceType === "regular") {
          if (
              Object.values(this.selectedData).length < 1 &&
              this.GET_INVOICE_CHECKED.data.length < 1
          ) {
            // this.$services.helpers.notification('Please select a invoices(s)', 'error', this)
            this.$toast.warning(this.$t("choose_invoice"));
          } else {
            this.sending = true;
            const array = [];
            this.GET_INVOICE_CHECKED.data.forEach((element) => {
              array.push(element.document_number);
            });
            const payload = {};
            if (this.selectedData.document_number) {
              payload.action = this.sendMethod;
              payload.invoices = [this.selectedData.document_number];
            } else {
              payload.action = this.sendMethod;
              payload.invoices = array;
            }
            this.$store
                .dispatch("clients/updateInvoiceAction", payload)
                .then((res) => {
                  this.sending = false;
                  this.action = "";
                  this.invoiceType = "";
                  this.sendMethod = "";
                  this.selectedData = {};
                  this.openModalSendInvoice = false;
                  this.$store.commit(
                      "clients/TOGGLE_ALL_INVOICE_CHECKBOX",
                      false
                  );
                  // this.$services.helpers.notification('Updated invoice(s) information', 'success', this)
                  this.$toast.success(this.$t("updated_invoice_info"));
                })
                .catch((err) => {
                  this.sending = false;
                  this.$services.helpers.notification(
                      err.response.data.message,
                      "error",
                      this
                  );
                });
          }
        } else if (this.invoiceType === "fortnox") {
          if (
              Object.values(this.selectedData).length < 1 &&
              this.GET_INVOICE_CHECKED.data.length < 1
          ) {
            // this.$services.helpers.notification('Please select a invoices(s)', 'error', this)
            this.$toast.warning(this.$t("choose_invoice"));
          } else {
            this.sending = true;
            const array = [];
            this.GET_INVOICE_CHECKED.data.forEach((element) => {
              array.push(parseInt(element.document_number));
            });

            //    const payload = {
            //   send_method: this.sendMethod,
            //   service: this.services,
            //   invoice_number: this.invoiceData.document_number,
            // };

            const payload = {};

            if (this.selectedData.document_number && !array.length) {
              payload.send_method = this.sendMethod;
              payload.service = this.services;
              payload.invoice_number = this.selectedData.document_number;

              this.$store
                  .dispatch("clients/sendInvoiceToNoxFinance", payload)
                  .then((res) => {
                    this.sending = false;
                    this.action = "";
                    this.invoiceType = "";
                    this.sendMethod = "";
                    this.selectedData = {};
                    this.openModalSendInvoice = false;
                    if (res.data.failed) {
                      this.openFailedInvoices = true;
                      this.failedInvoice = res.data.failed;
                    } else {
                      // this.$services.helpers.notification('Updated invoice(s) information', 'success', this)
                      this.$toast.warning(this.$t("updated_invoice_info"));
                    }
                  })
                  .catch((err) => {
                    this.sending = false;
                    this.$services.helpers.notification(
                        err.response.data.message,
                        "error",
                        this
                    );
                  });
            } else {
              payload.send_method = this.sendMethod;
              payload.service = this.services;
              payload.invoices = array;

              this.$store
                  .dispatch("clients/updateNoxFinanceAction", payload)
                  .then((res) => {
                    this.sending = false;
                    this.action = "";
                    this.invoiceType = "";
                    this.sendMethod = "";
                    this.selectedData = {};
                    this.openModalSendInvoice = false;
                    this.$store.commit(
                        "clients/TOGGLE_ALL_INVOICE_CHECKBOX",
                        false
                    );
                    if (res.data.failed) {
                      this.openFailedInvoices = true;
                      this.failedInvoice = res.data.failed;
                    } else {
                      // this.$services.helpers.notification('Updated invoice(s) information', 'success', this)
                      this.$toast.success(this.$t("updated_invoice_info"));
                    }
                  })
                  .catch((err) => {
                    this.sending = false;
                    this.$services.helpers.notification(
                        err.response.data.message,
                        "error",
                        this
                    );
                  });
            }
          }
        }
      }
    },
    applyAction() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.action === "") {
        // this.$services.helpers.notification('Please select an action', 'error', this)
        this.$toast.warning(this.$t("choose_action"));
      } else if (this.action !== "register" && this.action !== "send") {
        if (this.action === "schedule") {
          // empty the targetRow
          this.isBulk = true;
          this.targetRow = {};
          this.alreadyScheduled = [];
          this.bulkScheduled = [];
          this.GET_INVOICE_CHECKED.data.forEach((element) => {
            // schedule invoice sendout only for !cancelled and !fully_paid
            if (!element.cancelled && !element.fully_paid) {
              // if the element is not already scheduled, then add to bulkSchedule or else add to alreadyScheduled
              if (!element.scheduled_invoice_sending.length) {
                this.bulkScheduled.push(parseInt(element.document_number));
              } else {
                this.alreadyScheduled.push(element);
              }
            }
          });

          if (!this.bulkScheduled.length) {
            this.$toast.warning(this.$t("invalid_row_selection_invoice"));
            return;
          }
          // check if the selection contains any alreadyScheduled rows
          if (this.alreadyScheduled.length) {
            this.openAlreadyScheduledModal = true;
          } else {
            this.toggleScheduleInvoiceSendoutModal();
          }
          return;
        }
        if (this.GET_INVOICE_CHECKED.data.length < 1) {
          // this.$services.helpers.notification('Please select a invoices(s)', 'error', this)
          this.$toast.warning(this.$t("choose_invoice"));
        } else {
          this.applying = true;
          const array = [];
          this.GET_INVOICE_CHECKED.data.forEach((element) => {
            array.push(parseInt(element.document_number));
          });

          const payload = {
            action: this.action,
            invoices: array,
          };
          this.$store
              .dispatch("clients/updateInvoiceAction", payload)
              .then((res) => {
                this.applying = false;
                this.action = "";
                this.$store.commit("clients/TOGGLE_ALL_INVOICE_CHECKBOX", false);
                // this.$services.helpers.notification('Action carried out successfully', 'success', this)
                this.$toast.success(this.$t("action_success"));
              })
              .catch((err) => {
                this.applying = false;
                this.$services.helpers.notification(
                    err.response.data.message,
                    "error",
                    this
                );
              });
        }
      } else {
        if (this.action === "send") {
          this.openModalSendInvoice = true;
        }
      }
    },
    sendSingleInvoice(data) {
      this.selectedData = data;
      this.openModalSendInvoice = true;
    },
    getInvoiceCustomizeHeader() {
      this.$store
          .dispatch("clients/getInvoiceCustomizeHeader")
          .then((res) => {
            this.tableHeader = res.data.data;
            if (this.tableHeader.length > 0) {
              if (this.tableHeader.includes("address1")) {
                this.invoiceCustomizeItem = this.tableHeader;
                this.invoiceCustomizeItem.push("address");
              } else {
                this.invoiceCustomizeItem = this.tableHeader;
              }
            } else {
              if (INVOICE_DEFAULT) {
                Object.keys(INVOICE_DEFAULT).forEach((el) => {
                  this.invoiceCustomizeItem.push(el);
                });
              }
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$store.commit("auth/CLEAR_AUTH_USER", null);
              window.Bus.emit("logout");
            }
          });
    },
    onChangeCheckbox(e) {
      if (e.target.value === "address") {
        if (
            this.invoiceCustomizeItem.includes("address1") ||
            this.invoiceCustomizeItem.includes("address2")
        ) {
          this.removeAllInstances(this.invoiceCustomizeItem, "address1");
          this.removeAllInstances(this.invoiceCustomizeItem, "address2");
        } else {
          this.invoiceCustomizeItem.push("address1");
          this.invoiceCustomizeItem.push("address2");
        }
      }
    },
    registerPayment() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (
          this.paymentDate === "" ||
          this.paymentAmount === "" ||
          this.paymentMode === ""
      ) {
        // this.$services.helpers.notification('All field values required', 'error', this)
        this.$toast.warning(this.$t("fields_required"));
      } else if (!parseFloat(this.paymentAmount)) {
        this.$services.helpers.notification(
            "Please input a valid amount",
            "error",
            this
        );
        this.$toast.warning(this.$t("invalid_amount_input"));
      } else {
        this.sending = true;
        // const array = []
        // this.GET_INVOICE_CHECKED.data.forEach(element => {
        //     array.push(parseInt(element.id))
        // })

        const payload = {
          mode_of_payment_account: this.paymentMode,
          payment_date: this.paymentDate,
          invoice_number: this.selectedInvoicePayment.document_number,
          amount: this.paymentAmount,
        };
        this.$store
            .dispatch("clients/postInvoicePayment", payload)
            .then((res) => {
              this.sending = false;
              this.paymentMode = "";
              this.paymentDate = "";
              this.paymentAmount = "";
              this.openModalRegisterPayment = false;
              this.$store.commit("clients/TOGGLE_ALL_INVOICE_CHECKBOX", false);
              // this.$services.helpers.notification('Registered payment invoice', 'success', this)
              this.$toast.success(this.$t("invoice_payment_registered"));
            })
            .catch((err) => {
              this.sending = false;
              this.$services.helpers.notification(
                  err.response.data.message,
                  "error",
                  this
              );
            });
      }
    },
    updateInvoiceCustomization() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.invoiceCustomizeItem.length < 1) {
        // this.$services.helpers.notification('Please select columns', 'error', this)
        this.$toast.warning(this.$t("choose_columns"));
      } else {
        this.removeAllInstances(this.invoiceCustomizeItem, "address");
        this.updating = true;
        this.$store
            .dispatch("clients/updateInvoiceCustomization", {
              columns: this.invoiceCustomizeItem,
            })
            .then((res) => {
              this.updating = false;
              this.openInvoiceCustomizationModal = false;
              this.getInvoice();
              this.getInvoiceCustomizeHeader();
              this.$services.helpers.notification(
                  res.data.message,
                  "success",
                  this
              );
            })
            .catch((err) => {
              this.updating = false;
              this.$services.helpers.notification(
                  err.response.data.message,
                  "error",
                  this
              );
            });
      }
    },
    toggleAllCheckbox(e) {
      this.$store.commit(
          "clients/TOGGLE_ALL_INVOICE_CHECKBOX",
          this.toggleChangeCheckbox
      );
    },
    openRegisterModal(data) {
      this.selectedInvoicePayment = data;
      this.openModalRegisterPayment = true;
    },
    openCreateCopy(data) {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      // window.localStorage.setItem('__invoice__', JSON.stringify(data))
      this.$router.push({name: "createInvoice"});
    },
    removeAllInstances(arr, item) {
      arr.forEach((el, i) => {
        if (arr[i] === item) arr.splice(i, 1);
      });
    },
    toggleScheduleInvoiceSendoutModal() {
      // this function is called by bulkAction button and when the schedule icon in a row is clicked
      // this function opens schedule cacnellation modal and closes other modals like the warning modal for already scheduled rows
      this.openAlreadyScheduledModal = false;
      this.openScheduleInvoiceSendoutModal = true;
    },
    singleRowSchedule(data) {
      this.isBulk = false;
      this.targetRow = {...data};
      this.alreadyScheduled = [];
      this.bulkScheduled = [];

      // filter out scheduled_invoice_sending rows that have handled = true
      this.targetRow.scheduled_invoice_sending =
          this.targetRow.scheduled_invoice_sending.filter((el) => {
            return el.handled === false;
          });

      if (this.targetRow.scheduled_invoice_sending.length) {
        this.date_to_send =
            this.targetRow.scheduled_invoice_sending[0].date_to_send;
        this.invoice_type =
            this.targetRow.scheduled_invoice_sending[0].send_channel;
        this.distribution_method =
            this.targetRow.scheduled_invoice_sending[0].send_method;
        this.bookkeep = this.targetRow.scheduled_invoice_sending[0].bookkeep;
        this.send_failed_nox_as_reg =
            this.targetRow.scheduled_invoice_sending[0].send_failed_nox_as_reg;
      } else {
        this.date_to_send = TODAY;
        this.invoice_type = "";
        this.distribution_method = "";
        this.bookkeep = false;
        this.send_failed_nox_as_reg = false;
      }

      this.toggleScheduleInvoiceSendoutModal();
    },
    addScheduleInvoiceSendout() {
      this.scheduling = true;
      let invoices = [];

      // check if it is bulk or if it is coming from single row
      if (this.isBulk) {
        invoices = this.bulkScheduled;
      } else {
        invoices = [this.targetRow.document_number];
      }
      this.payload = {
        invoices: invoices,
        date_to_send: moment(this.date_to_send).format("YYYY-MM-DD"),
        send_channel: this.invoice_type,
        send_method: this.distribution_method,
        bookkeep: this.bookkeep,
        send_failed_nox_as_reg: this.send_failed_nox_as_reg,
      };
      this.$store
          .dispatch("clients/addScheduleInvoiceSendout", {
            invoices: invoices,
            date_to_send: moment(this.date_to_send).format("YYYY-MM-DD"),
            send_channel: this.invoice_type,
            send_method: this.distribution_method,
            bookkeep: this.bookkeep,
            send_failed_nox_as_reg: this.send_failed_nox_as_reg,
          })
          .then((res) => {
            this.clearScheduleInvoiceSendoutModalInputs();
            this.getInvoice();
            this.getInvoiceCustomizeHeader();
            this.$services.helpers.notification(
                res.data.message,
                "success",
                this
            );
          })
          .catch((err) => {
            // this.saving = false
            this.$services.helpers.notification(
                err.response.data.message,
                "error",
                this
            );
          });
    },
    deleteScheduleInvoiceSendout() {
      this.scheduling = true;
      this.$store
          .dispatch(
              "clients/deleteScheduleInvoiceSendout",
              this.targetRow.scheduled_invoice_sending[0].id
          )
          .then((res) => {
            // this.saving = false
            this.clearScheduleInvoiceSendoutModalInputs();
            this.getInvoice();
            this.getInvoiceCustomizeHeader();
            this.$services.helpers.notification(
                res.data.message,
                "success",
                this
            );
          })
          .catch((err) => {
            this.saving = false;
            this.$services.helpers.notification(
                err.response.data.message,
                "error",
                this
            );
          });
    },
    updateScheduleInvoiceSendout() {
      this.scheduling = true;
      this.$store
          .dispatch("clients/updateScheduleInvoiceSendout", {
            id: this.targetRow.scheduled_invoice_sending[0].id,
            date_to_send: moment(this.date_to_send).format("YYYY-MM-DD"),
            send_channel: this.invoice_type,
            send_method: this.distribution_method,
            bookkeep: this.bookkeep,
            send_failed_nox_as_reg: this.send_failed_nox_as_reg,
          })
          .then((res) => {
            // this.saving = false
            this.clearScheduleInvoiceSendoutModalInputs();
            this.getInvoice();
            this.getInvoiceCustomizeHeader();
            this.$services.helpers.notification(
                res.data.message,
                "success",
                this
            );
          })
          .catch((err) => {
            this.saving = false;
            this.$services.helpers.notification(
                err.response.data.message,
                "error",
                this
            );
          });
    },

    // helper function to clear invoice sendout modal inputs
    clearScheduleInvoiceSendoutModalInputs() {
      this.action = "";
      this.openScheduleInvoiceSendoutModal = false;
      this.date_to_send = TODAY;
      this.invoice_type = "";
      this.send_method = "";
      this.booked = false;
      this.send_failed_nox_as_reg = false;
      this.scheduling = false;
      this.isBulk = false;
      this.targetRow = {};
      this.alreadyScheduled = [];
      this.bulkScheduled = [];
    },

    slist(target) {
      // (A) SET CSS + GET ALL LIST ITEMS
      target.classList.add("slist");
      let items = target.getElementsByTagName("li"),
          current = null;

      // (B) MAKE ITEMS DRAGGABLE + SORTABLE
      for (let i of items) {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;

        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.ondragstart = (ev) => {
          current = i;
          for (let it of items) {
            if (it != current) {
              it.classList.add("hint");
            }
          }
        };

        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.ondragenter = (ev) => {
          if (i != current) {
            i.classList.add("active");
          }
        };

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.ondragleave = () => {
          i.classList.remove("active");
        };

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.ondragend = () => {
          for (let it of items) {
            it.classList.remove("hint");
            it.classList.remove("active");
          }
        };

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.ondragover = (evt) => {
          evt.preventDefault();
        };

        // (B7) ON DROP - DO SOMETHING
        i.ondrop = (evt) => {
          evt.preventDefault();
          if (i != current) {
            let currentpos = 0,
                droppedpos = 0;
            for (let it = 0; it < items.length; it++) {
              if (current == items[it]) {
                currentpos = it;
              }
              if (i == items[it]) {
                droppedpos = it;
              }
            }

            if (currentpos < droppedpos) {
              i.parentNode.insertBefore(current, i.nextSibling);
            } else {
              i.parentNode.insertBefore(current, i);
            }

            let index = 0;
            const temp = [];
            for (let it of items) {
              let text = it.getElementsByTagName("span")[0].textContent;
              let textKey = this.invoiceCustomizeItem.find(
                  (item) => this.$t(item) == text
              );
              // let textKeyIndex = this.invoiceCustomizeItem.indexOf(textKey);
              temp[index] = textKey;
              index++;
            }

            debounce(() => {
              for (let i = 0; i < temp.length; i++) {
                this.invoiceCustomizeItem[i] = temp[i];
              }
            }, 100)();
          }
        };
      }
    },
  },

  watch: {
    openInvoiceCustomizationModal: function (val) {
      if (val) {
        setTimeout(() => {
          this.slist(document.getElementById("sortlist"));
        }, 200);
      }
    },

    invoiceCustomizeItem: function (val) {
      const list = document.getElementById("sortlist");
      if (list) {
        this.slist(list);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO: change styling for active-filter class
.active-filter {
  box-shadow: 5px 5px 3px #888888 !important;
}

.list-summary {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  margin-bottom: 0px;
  font-weight: 600;
}

.applyFilter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.applyFilter p {
  margin: 0px;
}

.applyFilter select {
  height: 30px;
  background: #ffffff;
  margin-top: 10px;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
}

@-webkit-keyframes disable-pointer-events {
  0%,
  99% {
    pointer-events: none;
  }
}

@keyframes disable-pointer-events {
  0%,
  99% {
    pointer-events: none;
  }
}

.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content .headers {
  margin: 30px 0 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.content .headers h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content .headers a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .headers a:hover svg path {
  fill: #4946ae;
}

.content nav {
  margin: 20px 0 0 5px;
}

.el-clickable {
  cursor: pointer !important;
}

@media (max-width: 1094px) {
  .content nav .row {
    display: block;
  }
  .content nav .row > div:last-of-type {
    margin-top: 10px;
  }
  .content nav .row ul {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .content nav .row ul li {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.content nav ul {
  margin: 0;
  text-align: center;
  margin-top: 10px;
}

.content nav ul li {
  border-radius: 3.24215px;
  font-size: 11.3475px;
  line-height: 26px;
  color: #ffffff;
  cursor: pointer;
  width: 81.05px;
  height: 26.11px;
  -webkit-transition: color 0.3s ease-in-out,
  -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, -webkit-transform 0.35s ease-in-out,
  -webkit-box-shadow 0.3s ease-in-out;
  -o-transition: color 0.3s ease-in-out, transform 0.35s ease-in-out,
  box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, transform 0.35s ease-in-out,
  box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, transform 0.35s ease-in-out,
  box-shadow 0.3s ease-in-out, -webkit-transform 0.35s ease-in-out,
  -webkit-box-shadow 0.3s ease-in-out;
}

.content nav ul li:hover {
  -webkit-transform: translateY(-0.25em);
  -ms-transform: translateY(-0.25em);
  transform: translateY(-0.25em);
}

.content nav ul li.all {
  background: #c0beff;
}

.content nav ul li.all:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
  box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
}

.content nav ul li.booked {
  background: #4d82f3;
}

.content nav ul li.booked:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
  box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
}

.content nav ul li.not-booked {
  background: #efb008;
}

.content nav ul li.not-booked:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #efb008;
  box-shadow: 0 0.5em 0.5em -0.1em #efb008;
}

.content nav ul li.unpaid {
  background: #fb4b4b;
}

.content nav ul li.unpaid:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #fb4b4b;
  box-shadow: 0 0.5em 0.5em -0.1em #fb4b4b;
}

.content nav ul li.fully-paid {
  background: #419e6a;
}

.content nav ul li.fully-paid:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
  box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
}

.content nav ul li.voided {
  background: #64748b;
  color: #cbd4e1;
}

.content nav ul li.voided:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #64748b;
  box-shadow: 0 0.5em 0.5em -0.1em #64748b;
}

.content nav ul li:not(:last-of-type) {
  margin-right: 15px;
}

.content nav .right-parent {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 1097px) {
  .content nav .right-parent {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
}

.content nav .right-parent .filter {
  margin-right: 20px;
  margin-top: 10px;
}

.content nav .right-parent .filter label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content nav .right-parent .filter select {
  margin: 0 10px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content nav .right-parent .filter select:focus {
  outline: none;
}

.content nav .right-parent .filter button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content nav .right-parent .filter button:hover {
  background-color: #4947b0;
  color: #fff;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .filter {
    margin-top: 10px;
  }
}

@media (max-width: 575.98px) {
  .content nav .right-parent .filter {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content nav .right-parent .filter * {
    margin: 5px !important;
  }
}

.content nav .right-parent .search {
  margin-right: 10px;
  margin-top: 10px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 207.5px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .search {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .search {
    margin: 10px 0 0;
  }
}

.content nav .right-parent .search label {
  position: absolute;
  left: 0.5rem;
}

.content nav .right-parent .search input {
  border: none;
  width: 77%;
  margin-left: auto;
}

.content nav .right-parent .search input:focus {
  outline: none;
}

.content nav .right-parent .customize {
  margin-top: 10px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .customize {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .customize {
    -webkit-flex-basis: 100%;
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }
}

.content nav .right-parent .customize a {
  font-size: 14px;
  line-height: 22px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #5855d6;
  text-decoration: none;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content nav .right-parent .customize a svg {
  margin-right: 10px;
}

.content nav .right-parent .customize a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content nav .right-parent .customize a:hover {
  color: #4946ae;
}

.content nav .right-parent .customize a:hover svg path {
  fill: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
  0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
  0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  border-radius: 3.91229px;
  margin-top: 20px;
}

.content .box table {
  width: 100%;
  text-align: center;
  min-width: 970px;
}

.content .box table .checkbox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.content .box table .checkbox input {
  border: 0.978073px solid #64748b;
  border-radius: 3.91229px;
  height: 15px;
  width: 15px;
  position: relative;
  z-index: 33;
  background: #fffbfb;
  cursor: pointer;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox input:checked {
  border: none;
  background: transparent;
}

.content .box table .checkbox input,
.content .box table .checkbox input:checked {
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
}

.content .box table .checkbox input:checked ~ svg {
  display: block;
}

.content .box table .checkbox svg {
  position: absolute;
  height: 17px;
  width: 17px;
  display: none;
  z-index: 1;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox svg span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table thead {
  border-bottom: 0.978073px solid #cbd4e1;
}

.content .box table thead th {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  padding: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  //   white-space: nowrap;
}

.content .box table thead th:first-of-type {
  padding-left: 10px;
}

.content .box table thead th:last-of-type {
  padding-right: 10px;
}

.content .box table thead th span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table tbody tr {
  -webkit-transition: background 0.2s ease-out;
  -o-transition: background 0.2s ease-out;
  transition: background 0.2s ease-out;
}

.content .box table tbody tr:hover {
  background-color: #f8fbff !important;
}

.content .box table tbody tr:nth-child(odd) {
  background: #f1f4f9;
}

.content .box table tbody td {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  //   white-space: nowrap;
}

.content .box table tbody td a {
  text-decoration: none;
  display: block;
  color: #000;
  padding: 10px 5px;
}

.content .box table tbody td:first-of-type {
  padding-left: 10px;
}

.content .box table tbody td button {
  background: transparent;
  border: none;
  padding: 0;
}

.content .box table tbody td button:not(:last-of-type) {
  margin-right: 10px;
}

.content .box table tbody td button svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .box table tbody td button:hover svg path {
  fill: #4946ae;
}

.content .box table tbody tr .booked td a {
  color: #4d82f3;
}

.content .box table tbody tr.booked td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.notbooked td a {
  color: #efb008;
}

.content .box table tbody tr.notbooked td:not(:last-of-type) path {
  fill: #64748b;
}

.content .box table tbody tr.unpaid td a {
  color: #fb4b4b;
}

.content .box table tbody tr.unpaid td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.fullypaid td a {
  color: #419e6a;
}

.content .box table tbody tr.fullypaid td button:nth-child(1),
.content .box table tbody tr.fullypaid td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.voided td a {
  color: #64748b;
}

.content .box table tbody tr.voided td:not(:last-of-type) path {
  fill: #64748b;
}

.content .actions {
  margin-top: 30px;
  margin-bottom: 20px;
}

.content .actions label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .actions select {
  margin: 0 15px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content .actions select:focus {
  outline: none;
}

.content .actions button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .actions button:hover {
  background-color: #4947b0;
  color: #fff;
}

.currency-container {
  position: relative;
}

.currency {
  position: absolute;
  top: 41px;
  right: 10px;
}

@media (max-width: 575.98px) {
  .content .actions {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content .actions * {
    margin: 5px !important;
  }
}

.sync-btn {
  height: 30px;
  width: 31px;
  position: relative;
  margin-left: 10px;
}

.sync-btn i {
  position: absolute;
  top: 3px;
  left: 4px;
  font-size: 20px !important;
}

.content {
  padding: 90px 30px 10px !important;
}

// TODO: removing default styles of date picker
// .dp__input_icon_pad {
//   box-shadow: none !important;
//   background: transparent !important;
//   width: 100% !important;
// }
</style>
